import _ from "lodash";
import { SaveFilterType } from "models";

export const StorageUtil = {
  saveFilter,
  getFilter,
  clearFilter,

  setItem,
  getItem,
  removeItem,
};

function setItem(key: string, value: any) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
}

function getItem(key: string) {
  try {
    const valueStorage = localStorage.getItem(key);
    if (!valueStorage) return "";
    return JSON.parse(valueStorage);
  } catch (error) {
    console.log(error);
  }
}

function removeItem(key: string) {
  localStorage.removeItem(key);
}

function saveFilter(input: SaveFilterType) {
  try {
    let saveFilter = getItem("saveFilter");
    if (_.isArray(saveFilter) && saveFilter.length) {
      const idx = saveFilter.findIndex(
        (i: any) => i.module === input.module && i.tab === input.tab && i.subTab === input.subTab
      );
      if (idx > -1) {
        saveFilter[idx] = input;
      } else {
        saveFilter.push(input);
      }
      setItem("saveFilter", saveFilter);
    } else {
      setItem("saveFilter", [input]);
    }
  } catch (e) {
    console.log(e);
  }
}

function getFilter(module: string, tab: string, subTab: string) {
  const saveFilter = getItem("saveFilter") as SaveFilterType[];
  if (saveFilter.length) {
    return saveFilter.find((i) => i.module === module && i.tab === tab && i.subTab === subTab) || null;
  }
  return null;
}

function clearFilter(module: string) {
  const saveFilter = getItem("saveFilter") as SaveFilterType[];
  if (saveFilter.length) {
    const newFilter = saveFilter.filter((i) => i.module !== module);
    setItem("saveFilter", newFilter);
  }
}
